import { RESCHEDULING_FROM_REMINDER } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useReschedulingFromReminder() {
  return useIsFeatureEnabled(RESCHEDULING_FROM_REMINDER);
}
